/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { DEFAULT_COUNTRY_CODE, DEFAULT_LANGUAGE_CODE } from "@nf/constants";
import { IConfigurationModel } from "../models";

export class LocaleHelper {
  static getLocalizedAuthUrl(url: string, config?: IConfigurationModel) {
    const country = (config?.Country || DEFAULT_COUNTRY_CODE).toLowerCase();
    const language = config?.Language || DEFAULT_LANGUAGE_CODE;

    const path = url
      .replace("{country}", country)
      .replace("{language}", language);

    return path;
  }
}
